import { render } from "./AboutView.vue?vue&type=template&id=768024de&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=768024de&scoped=true&lang=css"
import "./AboutView.vue?vue&type=style&index=1&id=768024de&lang=css"
import "./AboutView.vue?vue&type=style&index=2&id=768024de&lang=css"

import exportComponent from "/Users/apple/Documents/Programing/sonak/sonak_2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768024de"]])

export default __exports__